import React, { useState } from 'react';
import useLinksData from '../../../hooks/useLinksData';
import useLeadData from '../../../hooks/useLeadData';
import usePaymentOptions from '../../../hooks/usePaymentOptions';
import useMAFSimulationData from '../../../hooks/useMAFSimulationData';


const ModalContactMeBody = ({ onCloseModal }) => {
    const { getBasename } = useLinksData();
    const { updateLead, sendFinancingSummaryEmail, updateSalesforceLead } = useLeadData();
    const { isMAF } = usePaymentOptions();
    const { ensureSimulation } = useMAFSimulationData();
    const basename = getBasename();

    // Evita reenvíos mientras el guardado está en curso
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const handleContactBy = async (data) => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setError(null);

        try {
            await submitContactPreference(data);
        } catch (err) {
            console.error("Error al registrar la preferencia de contacto:", err);
            setIsSubmitting(false);
            setError('No pudimos registrar tu preferencia de contacto. Por favor, inténtalo nuevamente.');
        }
    }

    const submitContactPreference = async (data) => {
        // Si es MAF, asegurar que la simulación exista y corresponda a la
        // configuración actual antes de enviar el email y actualizar el lead
        if (isMAF) {
            await ensureSimulation();
        }

        const goToThankYouPage = () => {
            // Usar el basename del contexto
            const baseUrl = basename || '/';
            window.location.href = `${baseUrl}/gracias`;
        }
        sendFinancingSummaryEmail();
        updateLead([{
            name: 'medio-de-contacto',
            value: data
        }, {
            name: 'quiero-que-me-contacten',
            value: 'Si'
        }], ()=> {
            updateSalesforceLead([{
                name: 'medio-de-contacto',
                value: data
            }, {
                name: 'quiero-que-me-contacten',
                value: 'Si'
            }]);
            goToThankYouPage();
        }, () => {
            // Antes se iba igual a /gracias: el cliente quedaba convencido de que
            // lo iban a contactar aunque su preferencia nunca se guardó
            setIsSubmitting(false);
            setError('No pudimos registrar tu preferencia de contacto. Por favor, inténtalo nuevamente.');
        });
    }

    return (
        <div className="modal-box">
            <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
            <div className="modal-body">
                <h3>¿Por que medio te gustaría que te contactemos?</h3>
                {error && <p className="error">{error}</p>}
                <div className={"buttons-container" + (isSubmitting ? " loading" : "")}>
                    <a className="btn outline-black" onClick={() => handleContactBy("whatsapp")}><img src={`${window._env_.STATIC_HOST}/static/website/images/icons/whatsapp-bw.svg`} />Whatsapp</a>
                    <a className="btn outline-black" onClick={() => handleContactBy("telefono")}><img src={`${window._env_.STATIC_HOST}/static/website/images/icons/speaker.svg`} />Llamada telefonica</a>
                    <a className="btn outline-black" onClick={() => handleContactBy("mail")}><img src={`${window._env_.STATIC_HOST}/static/website/images/icons/inbox.svg`} />Email</a>
                    {/* <a className="btn outline-black" onClick={() => handleContactBy("sin preferencia")}><img src={`${window._env_.STATIC_HOST}/static/website/images/icons/like-icon.svg`}/>No tengo preferencias</a> */}
                </div>
            </div>
        </div>
    )
}

export default ModalContactMeBody;